import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconContextWindow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 3.25C6.41421 3.25 6.75 3.58579 6.75 4C6.75 4.41421 6.41421 4.75 6 4.75H4C3.86193 4.75 3.75 4.86193 3.75 5V19C3.75 19.1381 3.86193 19.25 4 19.25H6C6.41421 19.25 6.75 19.5858 6.75 20C6.75 20.4142 6.41421 20.75 6 20.75H4C3.0335 20.75 2.25 19.9665 2.25 19V5C2.25 4.0335 3.0335 3.25 4 3.25H6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 3.25C20.9665 3.25 21.75 4.0335 21.75 5V19C21.75 19.9665 20.9665 20.75 20 20.75H18C17.5858 20.75 17.25 20.4142 17.25 20C17.25 19.5858 17.5858 19.25 18 19.25H20C20.1381 19.25 20.25 19.1381 20.25 19V5C20.25 4.86193 20.1381 4.75 20 4.75H18C17.5858 4.75 17.25 4.41421 17.25 4C17.25 3.58579 17.5858 3.25 18 3.25H20Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7822 16.1201C12.1783 16.1201 12.4999 16.456 12.5 16.8701C12.4999 17.2842 12.1784 17.6201 11.7822 17.6201H7.21777C6.82163 17.6201 6.5001 17.2842 6.5 16.8701C6.50014 16.456 6.82166 16.1201 7.21777 16.1201H11.7822Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7822 12.8701C17.1784 12.8701 17.5 13.2059 17.5 13.6201C17.4999 14.0343 17.1784 14.3701 16.7822 14.3701H7.21777C6.82161 14.3701 6.50006 14.0343 6.5 13.6201C6.50001 13.2059 6.82158 12.8701 7.21777 12.8701H16.7822Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7822 9.62012C17.1784 9.62012 17.5 9.95592 17.5 10.3701C17.4999 10.7843 17.1784 11.1201 16.7822 11.1201H7.21777C6.82161 11.1201 6.50006 10.7843 6.5 10.3701C6.50001 9.95592 6.82158 9.62012 7.21777 9.62012H16.7822Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7822 6.37012C17.1784 6.37012 17.5 6.70593 17.5 7.12012C17.4999 7.53424 17.1784 7.87012 16.7822 7.87012H12.2178C11.8216 7.87012 11.5001 7.53424 11.5 7.12012C11.5 6.70593 11.8216 6.37012 12.2178 6.37012H16.7822Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconContextWindow as ReactComponent };
